import { apiClient } from '@/services/apiClient'
import { NoiseData } from '@popety-io/types'

/**
 * Fetch noise statistics for a land property
 */
export const getNoiseStatisticsForLand = async (
  landId: string
): Promise<NoiseData> => {
  try {
    const response = await apiClient.get(`/noise/statistics/land/${landId}`)
    return response.data
  } catch (error) {
    console.error('Error fetching noise statistics for land:', error)
    throw error
  }
}

/**
 * Fetch noise statistics for a building
 */
export const getNoiseStatisticsForBuilding = async (
  buildingId: string
): Promise<NoiseData> => {
  try {
    const response = await apiClient.get(
      `/noise/statistics/building/${buildingId}`
    )
    return response.data
  } catch (error) {
    console.error('Error fetching noise statistics for building:', error)
    throw error
  }
}

/**
 * Fetch noise statistics for a custom polygon
 */
export const getNoiseStatisticsForPolygon = async (
  polygon: Array<{ lat: number; lon: number }>
): Promise<NoiseData> => {
  try {
    const response = await apiClient.post('/noise/statistics/polygon', {
      polygon,
    })
    return response.data
  } catch (error) {
    console.error('Error fetching noise statistics for polygon:', error)
    throw error
  }
}

/**
 * Fetch noise data for coordinates (creates a small buffer around the point)
 */
export const fetchNoiseData = async (params: {
  latitude: number
  longitude: number
}): Promise<NoiseData> => {
  try {
    // Create a small square polygon around the point (approximately 100m x 100m)
    const offset = 0.0005 // Approximately 50 meters in degrees
    const polygon = [
      { lat: params.latitude - offset, lon: params.longitude - offset },
      { lat: params.latitude + offset, lon: params.longitude - offset },
      { lat: params.latitude + offset, lon: params.longitude + offset },
      { lat: params.latitude - offset, lon: params.longitude + offset },
    ]

    return await getNoiseStatisticsForPolygon(polygon)
  } catch (error) {
    console.error('Error fetching noise data:', error)
    throw error
  }
}
